import { styled } from "../../../../styles";

// Matches the Sleep/measurement modal content: title + range header (with its
// own 40px left margin) sits at the top, content below.
//
// Intentionally NOT position: relative — the options (dots) button is absolutely
// positioned and must anchor to the modal tile (StyledTile) / pinned tile, just
// like MeasurementModal, so it lines up with the close button. A relative here
// would re-anchor it below the tile's top padding and misalign it vertically.
export const ModalContainer = styled("div", {
  height: "100%",
  width: "100%",
  padding: "24px 0 0 0",

  // Column layout so the table area fills the remaining height; this lets the
  // table's empty state center vertically within the modal (like the graphs).
  display: "flex",
  flexDirection: "column",
});

// Pull flush against the modal edges (the modal has 24px left padding), so the
// table spans full width like the Sleep/measurement tables. 14px font matches
// the Sleep table.
export const TableContainer = styled("div", {
  width: "calc(100% + 24px)",
  marginLeft: "-24px",
  fontSize: "14px",

  // Fill the space left under the header so the table (and its empty state,
  // which centers at ~50% height) occupies the middle of the modal.
  flex: 1,
  minHeight: 0,
});

// The options (dots) button sits in two contexts. As a modal it must align with
// the close button (right: 44, matching MeasurementModal); inside the pinned
// tile it aligns with the tile padding (right: 28, matching PinnedSection).
export const OptionsContainer = styled("div", {
  position: "absolute",
  top: 14,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  cursor: "pointer",

  variants: {
    pinned: {
      true: { right: 28 },
      false: { right: 44 },
    },
  },

  defaultVariants: {
    pinned: false,
  },
});
